import { render } from "./new-user.vue?vue&type=template&id=23b9ef68&scoped=true&ts=true"
import script from "./new-user.vue?vue&type=script&lang=ts&setup=true"
export * from "./new-user.vue?vue&type=script&lang=ts&setup=true"

import "./new-user.vue?vue&type=style&index=0&id=23b9ef68&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b9ef68"],['__file',"src/views/init/components/new-user.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23b9ef68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23b9ef68', __exports__)) {
    console.log('reload')
    api.reload('23b9ef68', __exports__)
  }
  
  module.hot.accept("./new-user.vue?vue&type=template&id=23b9ef68&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('23b9ef68', render)
  })

}


export default __exports__